<template>
  <header class="header">
    <div class="header__container">
      <Burger />
      <Menu />
      <div class="mobile-hidden header__logo1 img-w">
        <a href="https://Новыйгод.МЫВМЕСТЕ.рф/" target="_blank">
          <img src="@/assets/img/logo1.png" alt="">
        </a>
      </div>
      <div class="mobile-hidden header__logo2 img-w">
        <a href="https://Fadm.gov.ru/" target="_blank">
          <img src="@/assets/img/logo2.png" alt="">
        </a>
      </div>
      <div class="mobile-hidden header__logo3 img-w">
        <a href="https://Dobro.ru/" target="_blank">
          <img src="@/assets/img/logo3.png" alt="">
        </a>
      </div>
      <div class="mobile-hidden header__logo4 img-w">
        <a href="https://национальныепроекты.рф/?utm_source=Lenta_Rosmolodezh_Spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank">
          <img src="@/assets/img/logo4.png" alt="">
        </a>
      </div>
    </div>
  </header>
</template>

<script>
  import './header.scss'
  import Burger from "../Burger/Burger";
  import Menu from "../Menu/Menu";

  export default {
    name: "Header",
    components: {Menu, Burger}
  }
</script>

<style scoped>

</style>
